import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from "material-ui/Typography";
import AddressItem from '../items/AddressItem';
import Loader from '../../Parts/Loader';

const styles = () => ({
  root: {
    fontSize: '16px',
    color: '#181819',
    fontWeight: 'bold',
    paddingBottom: '9px',
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
  },

  loaderContainer: {
    height: "100px",
    position: "relative",
    width: "100%",
  },
});

class AddressList extends React.Component {
  render() {
    const { classes, items } = this.props;
    return (
      <div className={classes.root}>
        {(this.props.isLoading) ? (
          <div className={classes.loaderContainer}>
            <Loader type="color" size="large" />
          </div>
        ) : (
          items && items.length > 0 ? (
            items.map((item, i) => (
              <AddressItem
                item={item}
                key={i}
                goTo={this.props.goTo}
                statusSelected={this.props.statusSelected}
                dateSelected={this.props.dateSelected}
                ownerType={this.props.ownerType}
                keyword={this.props.keyword}
              />
            ))
          ) : (
            <Typography variant="subheading" style={{ marginTop: 20 }}>
              アイテムがありません。
            </Typography>
          )
        )}
      </div>
    )
  }
}

AddressList.propTypes = {
  classes: PropTypes.object.isRequired,
  items: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  isLoading: PropTypes.bool.isRequired,
  goTo: PropTypes.func.isRequired,
  statusSelected: PropTypes.object.isRequired,
  dateSelected: PropTypes.object.isRequired,
  ownerType: PropTypes.string.isRequired,
  keyword: PropTypes.string,
};

export default withStyles(styles)(AddressList);



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/lists/AddressList.jsx